import React, { Component } from 'react';

class WhyStorePickup extends Component {
  ref = React.createRef();

  componentDidMount() {
    const { observer = {} } = this.props;
    observer.observe(this.ref.current);
  }

  render() {
    const { images: { banners = [] } = {}, content: { headerText = '' } = {} } = this.props.data;
    return (
      <div className="storePickup" id="whystorepickup" ref={this.ref}>
        <div className="heading1">{headerText}</div>
        <div className="reasons">
          {banners.map((bannerObj, i) => {
            return (
              <div key={i} className="reason">
                <img className="logos" src={bannerObj.banner} alt={bannerObj?.alt} />
                <label dangerouslySetInnerHTML={{ __html: bannerObj.text }} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default WhyStorePickup;
